import React, { useState } from 'react';
import { Alert } from 'antd';
import { connect } from 'react-redux';
import SummaryCards from './SummaryCards';
import ProjectBreakdown from './ProjectBreakdown';
import EstimateStatusBreakdown from './EstimateStatusBreakdown';
import OrderBreakdown from './OrderBreakdown';
import InvoiceBreakdown from './InvoiceBreakdown';
import fetchProjectBreakdown from '../../Services/fetchProjectBreakdown';
import fetchEstimateBreakdown from '../../Services/fetchEstimateBreakdown';
import fetchOrderBreakdown from '../../Services/fetchOrderBreakdown';
import fetchInvoiceBreakdown from '../../Services/fetchInvoiceBreakdown';

const BasicDashboard = ({ 
  basicDashboardData, 
  fetchProjectBreakdown,
  fetchEstimateBreakdown,
  fetchOrderBreakdown,
  fetchInvoiceBreakdown,
}) => {
  const { data, loading, error } = basicDashboardData;
  const [showProjectBreakdown, setShowProjectBreakdown] = useState(false);
  const [showEstimateBreakdown, setShowEstimateBreakdown] = useState(false);
  const [showOrderBreakdown, setShowOrderBreakdown] = useState(false);
  const [showInvoiceBreakdown, setShowInvoiceBreakdown] = useState(false);
  
  const [projectBreakdownData, setProjectBreakdownData] = useState(null);
  const [estimateBreakdownData, setEstimateBreakdownData] = useState(null);
  const [orderBreakdownData, setOrderBreakdownData] = useState(null);
  const [invoiceBreakdownData, setInvoiceBreakdownData] = useState(null);

  const handleClickProjects = () => {
    const newState = !showProjectBreakdown;
    setShowProjectBreakdown(newState);
    setShowEstimateBreakdown(false);
    setShowOrderBreakdown(false);
    setShowInvoiceBreakdown(false);
    
    if (newState && !projectBreakdownData) {
      fetchProjectBreakdown().then((data) => {
        setProjectBreakdownData(data);
      });
    }
  };

  const handleClickEstimates = () => {
    const newState = !showEstimateBreakdown;
    setShowProjectBreakdown(false);
    setShowEstimateBreakdown(newState);
    setShowOrderBreakdown(false);
    setShowInvoiceBreakdown(false);
    
    if (newState && !estimateBreakdownData) {
      fetchEstimateBreakdown().then((data) => {
        setEstimateBreakdownData(data);
      });
    }
  };

  const handleClickOrders = () => {
    const newState = !showOrderBreakdown;
    setShowProjectBreakdown(false);
    setShowEstimateBreakdown(false);
    setShowOrderBreakdown(newState);
    setShowInvoiceBreakdown(false);
    
    if (newState && !orderBreakdownData) {
      fetchOrderBreakdown().then((data) => {
        setOrderBreakdownData(data);
      });
    }
  };

  const handleClickInvoices = () => {
    const newState = !showInvoiceBreakdown;
    setShowProjectBreakdown(false);
    setShowEstimateBreakdown(false);
    setShowOrderBreakdown(false);
    setShowInvoiceBreakdown(newState);
    
    if (newState && !invoiceBreakdownData) {
      fetchInvoiceBreakdown().then((data) => {
        setInvoiceBreakdownData(data);
      });
    }
  };

  if (error) {
    return (
      <Alert
        message="Error Loading Dashboard"
        description="Unable to load dashboard data. Please try refreshing the page."
        type="error"
        showIcon
        style={{ marginBottom: 24 }}
      />
    );
  }

  return (
    <div>
      <SummaryCards 
        data={data} 
        loading={loading} 
        onClickProjects={handleClickProjects}
        onClickEstimates={handleClickEstimates}
        onClickOrders={handleClickOrders}
        onClickInvoices={handleClickInvoices}
      />
      {showProjectBreakdown && projectBreakdownData && (
        <ProjectBreakdown data={{ projects: projectBreakdownData }} loading={false} />
      )}
      {showEstimateBreakdown && estimateBreakdownData && (
        <EstimateStatusBreakdown data={{ estimates: estimateBreakdownData }} loading={false} />
      )}
      {showOrderBreakdown && orderBreakdownData && (
        <OrderBreakdown data={{ orders: orderBreakdownData }} loading={false} />
      )}
      {showInvoiceBreakdown && invoiceBreakdownData && (
        <InvoiceBreakdown data={{ invoices: invoiceBreakdownData }} loading={false} />
      )}
    </div>
  );
};

const mapDispatchToProps = {
  fetchProjectBreakdown,
  fetchEstimateBreakdown,
  fetchOrderBreakdown,
  fetchInvoiceBreakdown,
};

export default connect(null, mapDispatchToProps)(BasicDashboard);
